import { render, staticRenderFns } from "./GsaDealer.vue?vue&type=template&id=90634a10&"
import script from "./GsaDealer.vue?vue&type=script&lang=js&"
export * from "./GsaDealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports